import { render } from "./EditStaffInfo.vue?vue&type=template&id=6d71a544"
import script from "./EditStaffInfo.vue?vue&type=script&lang=js"
export * from "./EditStaffInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__